import { FunctionComponent } from 'react'
import IconMenu from './IconMenu'
import IconHelp from './IconHelp'
import Logo from './Logo'

type HeaderProps = {
	onClickHelp?: () => void
	onClickMenu?: () => void
	onClickStats?: () => void
	subtitle?: string
}

const Header: FunctionComponent<HeaderProps> = ({ onClickHelp, onClickMenu, subtitle }) => (
	<header>
		<div className="header__left">
			<IconMenu onClick={onClickMenu} />
		</div>
		<div className="header__middle">
			<Logo />
			{subtitle && <small className="game__title">{subtitle}</small>}
		</div>
		<div className="header__right">
			<IconHelp onClick={onClickHelp} />
		</div>
	</header>
)

export default Header
